import { Checkbox, Text } from '@mantine/core';
import React, { useCallback } from 'react';
import { JiraFieldData2 } from '../../../../api/endpoints/jira';
import { Colors } from '../../../../ui';
import { Flexer } from '../../../dashboard/elements/LayoutElements';

export interface JiraToggleOption {
    value: string;
    id: string;
}

export interface TogglesInputProps {
    field: JiraFieldData2;
    value: JiraToggleOption[] | null;
    error?: boolean;
    onChange: (value: JiraToggleOption[] | null) => void;
    onSubmit: (value: JiraToggleOption[] | null) => void;
}

export const JiraTogglesInput = React.memo(({ field, value, error, onChange, onSubmit }: TogglesInputProps) => {

    const options = field.allowedValues as JiraToggleOption[];
    const isSelected = useCallback((optionId: string) => !!value?.some(x => x.id === optionId), [value]);

    const onSetOption = useCallback((option: JiraToggleOption, checked: boolean) => {
        const without = (value ?? []).filter(x => x.id !== option.id);
        const newValue = checked ? [...without, option] : without;
        const finalValue = newValue.length === 0 ? null : newValue;
        onChange(finalValue);
        onSubmit(finalValue);
    }, [value, onChange, onSubmit]);

    return <Flexer flex="column" gap=".5">
        <Flexer>
            <Text c={Colors.text}>{field.name}</Text>
            {field.required && <span style={{ color: 'red' }}> *</span>}
        </Flexer>
        {options.map(opt => (
            <Checkbox
                key={opt.id}
                size="sm"
                label={opt.value}
                checked={isSelected(opt.id)}
                error={error}
                onChange={(event) => onSetOption(opt, event.currentTarget.checked)}
            />
        ))}
    </Flexer>;
});
